<div class="import-modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ allowCsvOrXlsxImport ? ('GLOBAL.UPDATE_USER_ROLES' | translate) : ('GLOBAL.ADD_HOLES' | translate) }}</h4>
    <div class="header-icons pull-right">
      <i class="fas fa-upload" (click)="openFileSelector()"></i>
      <button type="button" class="close" aria-label="Close" (click)="hideModal()" title="{{'GLOBAL.FERMER' | translate}}">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div>
    <ngx-file-drop [multiple]="false" [accept]="getAcceptedFileTypes()" class="drag-drop" dropZoneLabel="Drop file here" (onFileDrop)="dropped($event)">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        @if (!selectedFile) {
          <div class="icone" (click)="openFileSelector()">
            <i class="fas fa-upload"></i>
            <p>{{'GLOBAL.DRAG&DROP' | translate}} {{'GLOBAL.THE_FILE' | translate}} {{ allowCsvOrXlsxImport ? '(.csv/.xlsx)' : '(.str)' }} {{'GLOBAL.HERE' | translate}}</p>
          </div>
        }
        @if (selectedFile) {
          <div class="file-preview">
            <p>{{ selectedFile.name }}</p>
            <button type="button" (click)="removeFile()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
          </div>
        }
        <input type="file" id="fileInput" style="display:none" (change)="onFileSelected($event)">
      </ng-template>
    </ngx-file-drop>
    <div class="checkbox-container">
      <label>
        <input type="checkbox" [(ngModel)]="swapXY" />
        <span>{{'GLOBAL.SWAPXY' | translate}}</span>
      </label>
    </div>
  </div>
  @if (allowCsvOrXlsxImport) {
    <div class="template-info">
      {{'GLOBAL.HELP_UPLOAD' | translate}} <a href=".\assets\templates\Upload_Roles_Template.xlsx" download>{{'GLOBAL.TEMPLATE' | translate}}</a>.
    </div>
  }

  <div class="footer">
    <button type="button" class="btn bg-secondary text-white" (click)="hideModal()">{{'GLOBAL.ANNULER' | translate}}</button>
    <button type="button" class="btn btn-outline-success" [disabled]="!selectedFile || isUploading" (click)="uploadFile()">
      @if (isUploading) {
        <i class="fas fa-spinner fa-spin"></i> {{'GLOBAL.CHARGEMENT' | translate}}
      } @else {
        {{'GLOBAL.UPLOAD' | translate}} {{'GLOBAL.FICHIER' | translate}}
      }
    </button>
  </div>

  <div bsModal #modalConfirmUpdate="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-child-name" [config]="{ backdrop: 'static' }">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <p class="modal-title-left"><strong>{{'GLOBAL.BLAST_NAME_UPDATE' | translate}}</strong></p>
          <p class="modal-text-center">{{'GLOBAL.BLAST_UPDATE_CONFIRM' | translate}}</p>
          <button type="button" class="btn btn-primary" [disabled]="isConfirming" (click)="confirmUpdate()">{{ 'GLOBAL.OUI' | translate
          }}</button>
          <button type="button" class="btn btn-secondary" [disabled]="isConfirming" (click)="declineUpdate()"
          style="margin-left: 20px;">{{ 'GLOBAL.NON' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
